<template>
  <div class="input-container">
    <div class="input-wrapper">
      <validation-observer ref="otpCode"
                           tag="form"
                           @submit.prevent="submitOtpCode">
        <base-v-input v-model="telephoneNumber"
                      :label="$t('checkout.existingNumber.telephoneNumber')"
                      :submitted="verificationSubmitted"
                      class="number-input"
                      container-class="phone-input"
                      name="phoneNumber"
                      rules="required|phoneNumberWithSpaces|max:15"
                      :maxlength="(13 + countSpecialChars).toString()"/>
        <div class="input-btn" @click="submitOtpCode">
          {{ !$props.otpCodeSent ? $t('checkout.existingNumber.sendCode') : $t('checkout.existingNumber.resendCode') }}
        </div>
      </validation-observer>
    </div>
    <div class="input-wrapper">
      <validation-observer ref="verifyOtpCode"
                           tag="form"
                           @submit.prevent="verifyOtp">
        <base-v-input v-model="smsCode"
                      :label="$t('checkout.existingNumber.smsCode')"
                      class="sms-input"
                      type="number"
                      name="otp"
                      maxlength="12"
                      pattern="\d*"
                      rules="required|otpCode"/>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import BaseVInput from '@/components/base/base-v-input'

export default {
  name: 'existing-mobile',
  components: { BaseVInput },
  props: {
    phone: String,
    code: String,
    otpCodeSent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      verificationSubmitted: false
    }
  },
  computed: {
    telephoneNumber: {
      get () {
        return this.$props.phone
      },
      set (val) {
        this.$emit('telephone-number', val)
      }
    },
    smsCode: {
      get () {
        return this.$props.code
      },
      set (val) {
        this.$emit('sms-code', val)
      }
    },
    countSpecialChars () {
      if (this.$props.phone.startsWith('00')) {
        return Math.min(this.telephoneNumber.replace(/[0-9a-zA-Z]/g, '').length + 2, 5)
      }
      return Math.min(this.telephoneNumber.replace(/[0-9a-zA-Z]/g, '').length, 5)
    }
  },
  methods: {
    async submitOtpCode () {
      const valid = await this.$refs.otpCode.validate()
      this.verificationSubmitted = true
      if (valid) {
        this.$emit('submit-otp')
      }
    },
    async verifyOtp () {
      const valid = await this.$refs.verifyOtpCode.validate()
      if (valid) {
        this.$emit('verify-otp')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-container {
  margin-top: 3rem;
  @media (map_get($breakpoints, sm)) {
    display: flex;
    margin: 3rem -1.2rem 0;
  }
}

.input-wrapper {
  @media (map_get($breakpoints, sm)) {
    flex: 0 0 calc(50% - 2.4rem);
    margin: 0 1.2rem;
  }
}

.input-wrapper {
  position: relative;

  .input-btn {
    position: absolute;
    right: 15px;
    top: 40px;
    color: $primary;
    font-size: 15px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
